import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_COMMON_API, 'data')

/**
 * 获取版本信息
 */
export function getVersionInfo() {
  return request.get('sysVersion/getVersionNo/supplier-center-web')
}
